import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { creditRatingScalesMapping } from 'shared/mappings';
import { ratingConstants } from 'shared/constants/company';
import { portfolioTypes } from 'shared/constants/portfolioTypes';
import { endorsementCreditRating } from 'shared/constants/summaryTab';
import { BlurWrapper } from 'ui';
import { SummaryCard, HeadSquare, SummaryCardLineChart } from 'modules/common/SummaryCard';
import { generalInformationMock } from 'modules/common/SummaryCard/Request/generalInformationMock';
import summaryTabHistoryData from 'assets/mockedData/summaryTabHistoryData.json';
import { shopProductsCategories } from 'modules/shop/shared/constants/shopProductsCategories';
import { ShopRelatedProductsModal } from 'modules/shop/components/ShopRelatedProductsModal';
import { ShopProductLines } from 'modules/shop/shared/constants/shopProductLines';
import { ratingTypes } from 'shared/constants/ratingTypes';

const data = {
  latestChange: {},
  generalInformation: {},
  levels: {},
  dates: {},
  documents: [],
  ratingScalesData: creditRatingScalesMapping(
    portfolioTypes.ESG_ANALYSIS,
    ratingConstants.entityReview,
  ),
  generalInformationList: generalInformationMock,
  endorsementList: endorsementCreditRating,
};

const useStyles = makeStyles({
  content: {
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    whiteSpace: 'pre-line',
  },
  unlockButton: {
    height: 50,
    margin: '0 auto',
    marginTop: 20,
    padding: '5px 30px',
    fontSize: '1rem',
  },
});

const useHeadSquareStyles = makeStyles({
  score: {
    fontWeight: 500,
    fontSize: 60,
  },
  max: {
    fontSize: 24,
  },
  scoreWidgetMainColumn: {
    height: '100%',
  },
});

type SummaryCardCSTProps = {
  onUnlocked: (unlocked: boolean) => void;
};

export const SummaryCardCST: FC<SummaryCardCSTProps> = ({ onUnlocked }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const headSquareClasses = useHeadSquareStyles();
  const [isRelatedProductsModalOpen, setRelatedProductsModalOpen] = useState(false);

  const openRelatedProductsModal = () => setRelatedProductsModalOpen(true);

  const handleUnlockedButton = (unlocked: boolean) => {
    setRelatedProductsModalOpen(false);
    onUnlocked(unlocked);
  };

  return (
    <>
      <BlurWrapper
        content={
          <Grid container className={classes.content}>
            <Button
              color="primary"
              variant="contained"
              onClick={openRelatedProductsModal}
              className={classes.unlockButton}
            >
              {t('UNLOCK')}
            </Button>
          </Grid>
        }
        active
      >
        {/* @ts-ignore */}
        <SummaryCard
          headSquare={
            <HeadSquare title={t('Short term')}>
              <span className={headSquareClasses.score}>7.3</span>
              <span className={headSquareClasses.max}>/10</span>
            </HeadSquare>
          }
          history={<SummaryCardLineChart history={summaryTabHistoryData} />}
          data={data}
        />
      </BlurWrapper>
      {isRelatedProductsModalOpen && (
        <ShopRelatedProductsModal
          data={{
            category: shopProductsCategories.esgAnalysis,
            countriesAndIndustries: [],
          }}
          open={isRelatedProductsModalOpen}
          onClose={() => handleUnlockedButton(false)}
          onConfirm={() => handleUnlockedButton(true)}
          module={ratingTypes.CLIMATE_STRESS_TEST}
        />
      )}
    </>
  );
};
